import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {catchError, tap} from "rxjs/operators";
import { HttpClient, HttpParams } from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {HelperService} from "../helper.service";
import {BaseService} from "./base.service";
import { Group } from '../models/group';
import { PageModel } from '../models/page-model';
import { AllSamplesGroupModel } from '../models/all-samples-group-model';
import { SampleGroupInfo } from '../models/Sample-Group-Info';

@Injectable({
  providedIn: 'root'
})
export class GroupService extends BaseService {

  private API_PIN_MANAGEMENT_URL = this.API_BASE_URL + "pin-management"; 

  constructor(
      private httpClient: HttpClient,
      public snackBar: MatSnackBar,
      public helper: HelperService,
  ) {
    super();
  }

  /// GET ///
      getPaginatedGroupListByTenantId(tenantId:number, page: number, size: number,searchQuery:string, fromDate:string, toDate: string, pinTypeId?: any): Observable<PageModel<Group[]>> {

        let params = new HttpParams()
            .set('page', page.toString())
            .append('size', size.toString())
    
        if (tenantId) {
            params = params.append('tenantId', tenantId.toString());
        }

        if (searchQuery) {
            params = params.append('searchQuery', searchQuery);
        }
    
        if (fromDate) {
            params = params.append('fromDate', fromDate);
        }
    
        if (toDate) {
            params = params.append('toDate', toDate);
        }

        if (pinTypeId) {
            params = params.append('pinTypeId', pinTypeId.toString());
        }
    
        return this.httpClient.get<PageModel<Group[]>>(this.API_PIN_MANAGEMENT_URL + `/samplegroups`, {params})
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving All Pin List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }


        getPaginatedGroupGriidingListByFieldId(fieldId:number, page?: number, size?: number, date?: string): Observable<PageModel<SampleGroupInfo[]>> {

        let params = new HttpParams()
            .set('page', page.toString())
            .append('size', size.toString())
    
        if (date) {
            params = params.append('date', date.toString());
        }
        return this.httpClient.get<PageModel<SampleGroupInfo[]>>(this.API_PIN_MANAGEMENT_URL + `/samplegroups?fieldId=${fieldId}`, {params})
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving All Sample Groups By Farm','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    getHistoricPinDetailsForGriidingBySampleGroupId(sampleGroupId:number): Observable<any> {

 
        return this.httpClient.get<any>(this.API_PIN_MANAGEMENT_URL + `/samplegroups/${sampleGroupId}/pins`)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Sample Group Pin Details By sample group ','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }

    getGroups(tenantId:number): Observable<any[]> {
      
      

        return this.httpClient.get<any[]>(this.API_PIN_MANAGEMENT_URL + `/samplegroups/dropdown?tenantId=${tenantId}`)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Retrieving Group List','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }
  //POST
    postNewGroup(userId: number, tenantId:number, name: string): Observable<any> {
        const body = {
          userId: userId,
          tenantId: tenantId,
          name: name,
        }
        

        return this.httpClient.post<any>(this.API_PIN_MANAGEMENT_URL + `/samplegroups`, body)
            .pipe(
                catchError((err) => {
                    this.hasError.next(true);
                    this.snackBar.open('Error Creating New Group','close', {
                        duration: 5000,
                    });
                    this.hasError.next(false);
                    return this.errorHandler(err);
                })
            );
    }



      //PUT
  updateMergeSampleGroups(groupId: number, mergeWithId: number): Observable<any> {
    const body = {}
    return this.httpClient.put<any>(this.API_PIN_MANAGEMENT_URL + `/samplegroups/${groupId}/merge?mergeWithId=${mergeWithId}` , body)
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Merging Sample Groups','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            }),
            tap(() => {
              this.snackBar.open('Merge Successful', 'close', {
                duration: 5000,
              });
            })
        );
  }

  updateSampleGroups(
            groupId:number,
            name:string,
            isGrid:boolean,
            gridRotation:number,
            gridSpacing:number,
            tenantId:number,
            userId:number,
  ): Observable<SampleGroupInfo> {

    const body = {
            groupId: groupId,
            name:name,
            isGrid:isGrid,
            gridRotation:gridRotation,
            gridSpacing:gridSpacing,
            tenantId:tenantId,
            userId:userId,
          }


          console.log(body, 'sample group body');
          
    return this.httpClient.put<SampleGroupInfo>(this.API_PIN_MANAGEMENT_URL + `/samplegroups/${groupId}` , body)
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Updating Sample Groups','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            }),
            tap(() => {
              this.snackBar.open('Update Successful', 'close', {
                duration: 5000,
              });
            })
        );
  }


//       // DELETE ///
  deleteGroupById(id: number): Observable<any> {
    
    return this.httpClient.delete(this.API_PIN_MANAGEMENT_URL + `/samplegroups/${id}`)
        .pipe(
            catchError((err) => {
              this.hasError.next(true);
              this.snackBar.open('Error Removing Sample Group','close', {
                duration: 5000,
              });
              this.hasError.next(false);
              return this.errorHandler(err);
            }),
            tap(() => {
              this.snackBar.open('Sample Group Removed Successfully', 'close', {
                duration: 5000,
              });
            })
        );
  }
}



  